module.exports = __webpack_public_path__ + "img/b3.195650b7.png";